import React from "react"
import NavbarMenuSlider from "./menu-slider-navbar/navbar-menu-slider"
import PropTypes from "prop-types"

const NavbarMenuSliderMain = ({ isOpen, setIsOpen, children }) => {
  return (
    <NavbarMenuSlider isOpen={isOpen} setIsOpen={setIsOpen}>
      {children}
    </NavbarMenuSlider>
  )
}

NavbarMenuSliderMain.propTypes = {
  isOpen: PropTypes.bool,
  setIsOpen: PropTypes.func.isRequired,
  children: PropTypes.any,
}
export default NavbarMenuSliderMain
